import {ironAppsInfo} from './index';
import {createElem} from '../../util/dom';
import {PerfMeasure} from '../perf-measure';
import {spaNavManager, InitAppFunc} from './spa-nav-manager';

/**
 * Attach an iron app to #mixpanel-application
 * @param initAppFunc - promise that returns iron app html element
 */
export async function attachApp(appName: string, initAppFunc: InitAppFunc, rollbar?: any) {
  if (!ironAppsInfo.hasOwnProperty(appName)) {
    throw new Error(`Invalid iron app: ${appName}`);
  }

  const initMeasure = new PerfMeasure(`init-app`).start();
  const appContainer = document.getElementById(`mixpanel-application`);
  appContainer.innerHTML = ``;

  try {
    spaNavManager.setInitAppFn(appName, initAppFunc);
    const appElem = await initAppFunc();
    appContainer.appendChild(appElem);
  } catch (err) {
    // __isRedirecting means browser will redirect to the login page for oauth access token flow
    // rather than showing a momentary mp-alert that flashes and logs a console error (which fails smoke tests)
    // show a useful message to the user that they'll be redirected
    if (window[`__isRedirecting`]) {
      appContainer.innerHTML = `<mp-spinner></mp-spinner> Redirecting to login page...`;
    } else {
      appContainer.appendChild(createElem(`mp-alert`, {open: true}, err.toString()));
      console.error(err);

      if (rollbar) {
        rollbar.error(err);
      }
    }
  }

  initMeasure.end();
}
